import React from "react";

import Project from "../modules/Project";

export default function ProjectPage() {
  return <Project />;
}
